import { 
  PAGE_WIDTH,
  MARGIN_LEFT,
  MARGIN_RIGHT,
  MARGIN_Y,
  CONTENT_WIDTH,
  bottomMarginItemGlobal,
  lineHeightGlobal,
  INTEND_GLOBAL
}  from "../../utils/pdfConstants";


export function renderSubsectionListBlock({ data, content }) {
  const subsections = data?.subsections || [];

  if (subsections.length === 0) {
    content.push({
      text: "Ei aliosioita.",
      style: "paragraph",
      margin: [0, 5, 0, 10],
    });
    return;
  }

  subsections.forEach((sub) => {
    const title = sub.name || "Aliosio";
    const description = sub.description?.trim() || "";
    const conclusion = sub.conclusion?.trim() || "";
    const actions = Array.isArray(sub.actionItems) ? sub.actionItems : [];

    // Title
    content.push({
      text: title.toUpperCase(),
      style: "subsectionHeader",
      margin: [0, 13, 0, 15],
    });

    // Description
    if (description) {
      content.push({
        text: description,
        style: "paragraph",
        margin: [0, 0, 0, 6],
      });
    }

    // Conclusion
    if (conclusion) {
      content.push({
        text: conclusion,
        style: "paragraph",
        italics: true,
        margin: [0, 0, 0, 6],
      });
    }

    // Toimenpide-ehdotukset
    if (actions.length > 0) {
      const ehdotukset = actions.map(a => a.text).filter(Boolean);

      content.push({
        text: "Toimenpide-ehdotukset:",
        bold: true,
        margin: [0, 5, 0, 3],
      });

      if (ehdotukset.length > 0) {
        content.push({
          ul: ehdotukset,
          margin: [10, 0, 0, 8],
          style: "paragraph",
        });
      } else {
        content.push({
          text: "– Ei ehdotuksia –",
          style: "paragraph",
          margin: [10, 0, 0, 8],
        });
      }
    }
  });
}
